/* tslint:disable */
import { TemperatureProfileData } from './temperature-profile-data';

/**
 */
export class ViewTemperatureProfile {
    minScaleTemp?: number;
    maxScaleTemp?: number;
    minScaleConv?: number;
    maxScaleConv?: number;
    tempChartData?: TemperatureProfileData;
    convChartData?: TemperatureProfileData;
    imageTemp?: string;
    imageConv?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-temperature-profile.ts